<div id="top-space"></div>
<section id="job" class="parallax-section pt-5">
	<div class="container">
		<div class="wow fadeInUp col-md-12 col-sm-12" data-wow-delay="0.4s">
			<div class="section-title text-center">
				<h2 class="content-title">Job List</h2>
			</div>
		</div>
		<div class="row">

			<!-- Job 12 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12 table-grid" data-wow-delay="0.5s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/flag-of-Oman.png" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> Dalmar Engineering Consultancy</span> 
								</h6>
								<h3>CAD DESIGNER</h3>
								<h4>Oman</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job12">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>


			<!-- Job 11 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12" data-wow-delay="0.6s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/flag-of-Bahrain.png" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> Company Smart Security & Safety</span> 
								</h6>
								<h3>10 ELECTRONICS TECHNICIAN/ENGINEER</h3>
								<h4>Bahrain</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job11">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>

			<!-- Job 10 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12 table-grid" data-wow-delay="0.7s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/flag-of-Bahrain.png" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> Company Smart Security & Safety</span> 
								</h6>
								<h3>2 ACCOUNTANT</h3>
								<h4>Bahrain</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job10">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>

			<!-- Job 9-->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12" data-wow-delay="0.8s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/flag-of-Bahrain.png" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> Company Smart Security & Safety</span> 
								</h6>
								<h3>1 PURCHASE SPECIALIST</h3>
								<h4>Bahrain</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job9">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>

			<!-- Job 8 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12 table-grid" data-wow-delay="0.9s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/saudi-flag.jpg" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> KATAKEET AL OMR BARBER FOR HAIR CUTTING - ABHA CITY KSA</span> 
								</h6>
								<h3>HIRING 4 BARBERS</h3>
								<h4>Saudi Arabia</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#9">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>

			<!-- Job 7 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12" data-wow-delay="0.1s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/flag-of-Qatar.png" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> IMCO Engineering & Construction W.L.L. Qatar</span> 
								</h6>
								<h3>Analyzer Supervisor and Analyzer Technician</h3>
								<h4>Qatar</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job7">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>

			<!-- Job 6 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12 table-grid" data-wow-delay="0.1s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/flag-of-Bahrain.png" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> Smart Security & Safety - Manama, Kingdom Of Bahrain</span> 
								</h6>
								<h3>Storekeeper Cum Driver <p>(GCC experience/license)</p></h3>
								<h4>Bahrain</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job6">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>

			<!-- Job 1 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12" data-wow-delay="0.1s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/flag-of-hongkong.png" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> Hong Kong</span> 
								</h6>
								<h3>DOMESTIC HELPER</h3>
								<h4>Hong Kong</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job1">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>

			<!-- Job 2 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12 table-grid" data-wow-delay="0.1s">
				<div class="tab-content">

					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/saudi-flag.jpg" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> KING SALMAN ARMED FORCES HOSPITAL, TABUK, KSA</span> 
								</h6>
								<h3>FEMALE REGISTERED NURSES</h3>
								<h4>Saudi Arabia</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job2">
								View Details
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Job 3 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12" data-wow-delay=".1s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/saudi-flag.jpg" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> Armed Forces Hospital (King Abdulaziz Airbase) Dhahran, KSA</span> 
								</h6>
								<h3>FEMALE REGISTERED NURSES</h3>
								<h4>Saudi Arabia</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job3">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>
			
			<!-- Job 4 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12 table-grid" data-wow-delay="0.1s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/saudi-flag.jpg" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> PRINCE SULTAN MILITARY MEDICAL CITY, RIYAHD, KSA</span> 
								</h6>
								<h3>FEMALE REGISTERED NURSES</h3>
								<h4>Saudi Arabia</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job4">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>

			<!-- Job 5 -->
			<div class="wow fadeInUp tabtext col-md-12 col-sm-12" data-wow-delay=".1s">
				<div class="tab-content">
			
					<div role="tabpanel" class="tab-pane active" id="fday">
						<div class="row">
							<div class="col-md-2 col-sm-2">
								<img src="/assets/images/country/saudi-flag.jpg" class="img-fluid country-flag" alt="program">
							</div>
							<div class="col-md-8 col-sm-10">
								<h6>
									<span><i class="fa fa-map-marker"></i> Sharuorah Armed forces Hospital, Sharurah, KSA</span> 
								</h6>
								<h3>FEMALE REGISTERED NURSES</h3>
								<h4>Saudi Arabia</h4>						
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center">
								<!-- Button trigger modal -->
								<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#job5">
								View Details
								</button>
							</div>
						</div>
		
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!--Job 1 Modal -->
<div class="modal fade" id="job1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel">Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> Hong Kong</span> 
					</h6>
					<h3>Domestic Helper</h3>
					<h4>Hong Kong</h4>						
				</div>
				<div class="col pt-3">
					<h6>Qualification:</h6>
					<ul>
						<li>Female</li>
						<li>25-42 Years old</li>
						<li>Physically Fit</li>
						<li>Any Abroad/ Local Experience</li>
					</ul>
				</div>
			
				<div class="col pt-3">
					<h6>Requirements Needed:</h6>
					<ul>
						<li>PASSPORT</li>
						<li>NCII / TESDA CERTIFICATE (DOMESTIC WORKS)</li>
						<li>RESUME WITH 2X2 PICTURE</li>
						<li>EMPLOYMENT CERTIFICATION</li>
					</ul>
					<h6>We appreciate it if you can refer relatives, friends, and colleagues in industry that are willing to apply.
					Thank you very much.</h6>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 2 Modal -->
<div class="modal fade" id="job2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel">Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> King Salman Armed Forces Hospital, Tabuk, KSA</span> 
					</h6>
					<h3>FEMALE REGISTERED NURSES</h3>
					<h4>Saudi Arabia</h4>						
				</div>
				<div class="col pt-3">
					<h6>Qualification:</h6>
					<ul>
						<li>23- 50 years old below</li>
						<li>Registered Nurses</li>
						<li>Male and Female</li>
						<li>With minimum of 2 years experience locally as a Staff Nurse in any Clinical/Hospital setting.</li>
					</ul>
				</div>
				<div class="col">
					<h6>Benefits:</h6>
					<ul>
						<li>2 years contract with yearly vacation</li>
						<li>Tax Free Salary</li>
						<li>FREE Accommodation and Transportation (hospital-accommodation vice versa)</li>
						<li>FREE Entry and Exit visa</li>
						<li>FREE Iqama</li>
					</ul>
				</div>
				<div class="col pt-3">
					<h6>Requirements Needed:</h6>
					<ul>
						<li>Updated Resume with recent photo</li>
						<li>Diploma, TOR and RLE</li>
						<li>PRC ID, Board Rate, & Certificate/Lupon</li>
						<li>DataFlow Verification (Diploma, PRC ID, COE)</li>
						<li>Saudi Council ID - Ex-Saudi</li>
						<li>Prometric Exam Result - Ist timer (done once selected)</li>
						<li>Employment Certificates </li>
						<li>Recommendation letter at least 2(Supervisor/chief nurse/head nurse)</li>
						<li>Seminars & Training Certificates</li>
						<li>Passport & NBI copy (1 year valid)</li>
						<li>Exit Visa (Ex Saudi)</li>
						<li>Iqama Copy (Ex-Saudi)</li>
						<li>Vaccine Certificate/Card (Covid19).</li>
					</ul>
						<h6>We appreciate it if you can refer relatives, friends, and colleagues in industry that are willing to apply.
						Thank you very much.</h6>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 3 Modal -->
<div class="modal fade" id="job3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel">Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> Armed Forces Hospital (King Abdulaziz Airbase) Dhahran, KSA</span> 
					</h6>
					<h3>FEMALE REGISTERED NURSES</h3>
					<h4>Saudi Arabia</h4>						
				</div>
				<div class="col pt-3">
					<h6>Qualification:</h6>
					<ul>
						<li>23- 50 years old below</li>
						<li>Registered Nurses</li>
						<li>Male and Female</li>
						<li>With minimum of 2 years experience locally as a Staff Nurse in any Clinical/Hospital setting.</li>
					</ul>
				</div>
				<div class="col">
					<h6>Benefits:</h6>
					<ul>
						<li>2 years contract with yearly vacation</li>
						<li>Tax Free Salary</li>
						<li>FREE Accommodation and Transportation (hospital-accommodation vice versa)</li>
						<li>FREE Entry and Exit visa</li>
						<li>FREE Iqama</li>
					</ul>
				</div>
				<div class="col pt-3">
					<h6>Requirements Needed:</h6>
					<ul>
						<li>Updated Resume with recent photo</li>
						<li>Diploma, TOR and RLE</li>
						<li>PRC ID, Board Rate, & Certificate/Lupon</li>
						<li>DataFlow Verification (Diploma, PRC ID, COE)</li>
						<li>Saudi Council ID - Ex-Saudi</li>
						<li>Prometric Exam Result - Ist timer (done once selected)</li>
						<li>Employment Certificates </li>
						<li>Recommendation letter at least 2(Supervisor/chief nurse/head nurse)</li>
						<li>Seminars & Training Certificates</li>
						<li>Passport & NBI copy (1 year valid)</li>
						<li>Exit Visa (Ex Saudi)</li>
						<li>Iqama Copy (Ex-Saudi)</li>
						<li>Vaccine Certificate/Card (Covid19).</li>
					</ul>
						<h6>We appreciate it if you can refer relatives, friends, and colleagues in industry that are willing to apply.
						Thank you very much.</h6>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 4 Modal -->
<div class="modal fade" id="job4" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel">Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> PRINCE SULTAN MILITARY MEDICAL CITY, RIYAHD, KSA</span> 
					</h6>
					<h3>FEMALE REGISTERED NURSES</h3>
					<h4>Saudi Arabia</h4>						
				</div>
				<div class="col pt-3">
					<h6>Qualification:</h6>
					<ul>
						<li>23- 50 years old below</li>
						<li>Registered Nurses</li>
						<li>Male and Female</li>
						<li>With minimum of 2 years experience locally as a Staff Nurse in any Clinical/Hospital setting.</li>
					</ul>
				</div>
				<div class="col">
					<h6>Benefits:</h6>
					<ul>
						<li>2 years contract with yearly vacation</li>
						<li>Tax Free Salary</li>
						<li>FREE Accommodation and Transportation (hospital-accommodation vice versa)</li>
						<li>FREE Entry and Exit visa</li>
						<li>FREE Iqama</li>
					</ul>
				</div>
				<div class="col pt-3">
					<h6>Requirements Needed:</h6>
					<ul>
						<li>Updated Resume with recent photo</li>
						<li>Diploma, TOR and RLE</li>
						<li>PRC ID, Board Rate, & Certificate/Lupon</li>
						<li>DataFlow Verification (Diploma, PRC ID, COE)</li>
						<li>Saudi Council ID - Ex-Saudi</li>
						<li>Prometric Exam Result - Ist timer (done once selected)</li>
						<li>Employment Certificates </li>
						<li>Recommendation letter at least 2(Supervisor/chief nurse/head nurse)</li>
						<li>Seminars & Training Certificates</li>
						<li>Passport & NBI copy (1 year valid)</li>
						<li>Exit Visa (Ex Saudi)</li>
						<li>Iqama Copy (Ex-Saudi)</li>
						<li>Vaccine Certificate/Card (Covid19).</li>
					</ul>
						<h6>We appreciate it if you can refer relatives, friends, and colleagues in industry that are willing to apply.
						Thank you very much.</h6>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 5 Modal -->
<div class="modal fade" id="job5" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel">Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> Sharuorah Armed forces Hospital, Sharurah, KSA</span> 
					</h6>
					<h3>FEMALE REGISTERED NURSES</h3>
					<h4>Saudi Arabia</h4>						
				</div>
				<div class="col pt-3">
					<h6>Qualification:</h6>
					<ul>
						<li>23- 50 years old below</li>
						<li>Registered Nurses</li>
						<li>Male and Female</li>
						<li>With minimum of 2 years experience locally as a Staff Nurse in any Clinical/Hospital setting.</li>
					</ul>
				</div>
				<div class="col">
					<h6>Benefits:</h6>
					<ul>
						<li>2 years contract with yearly vacation</li>
						<li>Tax Free Salary</li>
						<li>FREE Accommodation and Transportation (hospital-accommodation vice versa)</li>
						<li>FREE Entry and Exit visa</li>
						<li>FREE Iqama</li>
					</ul>
				</div>
				<div class="col pt-3">
					<h6>Requirements Needed:</h6>
					<ul>
						<li>Updated Resume with recent photo</li>
						<li>Diploma, TOR and RLE</li>
						<li>PRC ID, Board Rate, & Certificate/Lupon</li>
						<li>DataFlow Verification (Diploma, PRC ID, COE)</li>
						<li>Saudi Council ID - Ex-Saudi</li>
						<li>Prometric Exam Result - Ist timer (done once selected)</li>
						<li>Employment Certificates </li>
						<li>Recommendation letter at least 2(Supervisor/chief nurse/head nurse)</li>
						<li>Seminars & Training Certificates</li>
						<li>Passport & NBI copy (1 year valid)</li>
						<li>Exit Visa (Ex Saudi)</li>
						<li>Iqama Copy (Ex-Saudi)</li>
						<li>Vaccine Certificate/Card (Covid19).</li>
					</ul>
						<h6>We appreciate it if you can refer relatives, friends, and colleagues in industry that are willing to apply.
						Thank you very much.</h6>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 6 Modal -->
<div class="modal fade" id="job6" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel">Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> Smart Security & Safety - Manama, Kingdom Of Bahrain</span> 
					</h6>
					<h3>STOREKEEPER CUM DRIVER <p>(GCC experience/license)</p></h3>
					<h4>Bahrain</h4>						
				</div>
				<div class="col pt-3">
					<h6>Qualification:</h6>
					<ul>
						<li>26-35 Years old</li>
						<li>Preferably Male</li>
						<li>Must be organized and punctual.</li>
						<li>Well-presented and professional.</li>
						<li>Prior experience in retail, preferably in a management position,  would be advantageous. </li>
						<li>Excellent verbal and written communication skills.</li>
						<li>Proficient in Microsoft Office.</li>
					</ul>
				</div>
				<div class="col">
					<h6>Store Keeper Responsibilities: </h6>
					<ul>
						<li>Keeping a record of sales and restocking the store accordingly</li>
						<li>Planning promotional campaigns for new products or specials.</li>
						<li>Ensuring that the store is kept clean and organized.</li>
						<li>Mediating any confrontations between staff and clients, and de-escalating the situation.</li>
					</ul>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 7 Modal -->
<div class="modal fade" id="job7" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel">Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> IMCO ENGINEERING & CONSTRUCTION W.L.L QATAR</span> 
					</h6>
					<h3>HIRING FOR THE FOLLOWING POSITION</h3>
					<h4>Qatar</h4>						
				</div>
				<div class="col pt-3">
					<h6>Analyzer Supervisor (1 No):</h6>
					<ul>
						<li>Diploma in Instrumentation
							Supervise and guide servicing, repair
							And calibration dioxide, oxygen,
							Oil in water, salt, moisture
							CEM analyzers.</li>
						<li>Experience in Oil and Gas</li>
					</ul>
				</div>
				<div class="col">
					<h6>Analyzer Technician (2 Nos.)</h6>
					<ul>
						<li>High School Servicing repair and calibration of analyzers water,
							Density, carbon dioxide, oxygen, oil in water, salt moisture, CEMS analyzers.</li>
						<li>Experience in Oil and Gas.</li>
					</ul>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 8 Modal -->
<div class="modal fade" id="job8" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel">Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> KATAKEET AL OMR BARBER FOR HAIR CUTTING - ABHA CITY KSA</span> 
					</h6>
					<h3>HIRING 4 BARBERS</h3>
					<h4>Saudi Arabia</h4>						
				</div>
				<div class="col pt-3">
					<h6>Analyzer Supervisor (1 No):</h6>
					<ul>
						<li>Cutting </li>
						<li>Trimming</li>
						<li>Styling</li>
						<li>Coloring Client’s hair according to their instructions</li>
						<li>Fitting and grooming hairpieces</li>
					</ul>
				</div>
				<div class="col">
					<h5>SALARY SR2250</h5>
					<P>+ SR300 Food allowance</P>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 9 Modal -->
<div class="modal fade" id="job9" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel"> Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> Company Smart Security & Safety</span> 
					</h6>
					<h3>1 PURCHASE SPECIALIST</h3>
					<h4>Bahrain</h4>						
				</div>
				<div class="col pt-3">
					<h6>Job Descriptions: </h6>
					<ul>
						<li>Researching and identifying prospective suppliers.</li>
						<li>Liasing with internal project teams and maintaining strong supplier relations.</li>
						<li>Evaluating products and suppliers according to key business criteria.</li>
						<li>Preparin proposals,  requesting quotes, and negotiating purchase terms and conditions.</li>
						<li>Preparing and issuing purchase orders and agreements.</li>
						<li>Monitoring supplier performance and resolving issues and concerns.</li>
						<li>Inspecting and evaluating the quality of purchased items and resolving shortcomings.</li>
						<li>Analyzing industry and demand trends and supporting senior management with the development and implementation of sourcing strategies.</li>
						<li>Preparing reports and maintaining accurate inventory and procurement records.
							Complying with company policies, procedures, and regulatory standards.</li>
					</ul>
				</div>
				<!-- <div class="col">
					<h5>SALARY SR2250</h5>
					<P>+ SR300 Food allowance</P>
				</div> -->
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 10 Modal -->
<div class="modal fade" id="job10" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel"> Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> Company Smart Security & Safety</span> 
					</h6>
					<h3>2 ACCOUNTANT</h3>
					<h4>Bahrain</h4>						
				</div>
				<div class="col pt-3">
					<h6>Job Descriptions: </h6>
					<ul>
						<li>Preferably graduate of Bachelor of Science in Accountancy</li>
						<li>At least 2-year experience in general accounting and taxation
						</li>
						<li>Well knowledgeable in Microsoft Office tools specially MS Excel 
						</li>
						<li>Keen to details and can work with less supervision
							Knowledgeable in business status analysis</li>
					</ul>
				</div>
				<!-- <div class="col">
					<h5>SALARY SR2250</h5>
					<P>+ SR300 Food allowance</P>
				</div> -->
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>


<!--Job 11 Modal -->
<div class="modal fade" id="job11" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel"> Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> Company Smart Security & Safety</span> 
					</h6>
					<h3>10 ELECTRONICS TECHNICIAN/ENGINEER</h3>
					<h4>Bahrain</h4>						
				</div>
				<div class="col pt-3">
					<h6>Job Descriptions: </h6>
					<ul>
						<li>Must be male, 25~35 years old  2~3 Years’ Experience on the same field</li>
						<li>Knowledgeable in CCTV, Alarm, Security System, Access Control</li>
						<li>Knowledgeable in Electronics Repairs e.g. city camera, dvr, etc</li>
						<li>Graduate of Engineering, Technical or Vocational Course</li>
						<li>Experience Technical Sales (MUST)</li>
					</ul>
					<h6 style="color:blue">Fresh Graduate can apply </h6>
				</div>
				<!-- <div class="col">
					<h5>SALARY SR2250</h5>
					<P>+ SR300 Food allowance</P>
				</div> -->
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

<!--Job 12 Modal -->
<div class="modal fade" id="job12" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalLabel"> Job Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="col" style="border-bottom: 1px solid #dee2e6;">
					<h6>
						<span><i class="fa fa-map-marker"></i> Dalmar Engineering Consultancy</span> 
					</h6>
					<h3>CAD DESIGNER</h3>
					<h4>Oman</h4>						
				</div>
					
				<div class="col pt-3">
					<h5 class="pb-3"><i>INSTRUMENTAL | MECHANICAL PIPING</i></h5>
					<h6>Job Descriptions: </h6>
					<ul>
						<li>Proficient in AutoCAD 2D is a must.Previous experience with Oil and Gas projects is a must.</li>
						<li>Design high quality, robust, and cost-effective CAD product models by preparing routine layouts, detail drawings, sketches, diagrams...ETC.</li>
						<li>Revise and update CAD drawings as required. Understands and follows a CAD standard drawing database/system.
							Understand the as built concept</li>
						<li>Develop or modify working drawings from sketches, descriptions or Red Line Markups</li>
						<li>Microsoft Excel knowledge is required.</li>
						<li>Update project DCR/Tracker with drawings/documents status as required.</li>
						<li>Self-organized and Work closely with other Designers and Engineers to ensure a coordinated design.</li>
						<i>Represented elevations and contours in structural designs accurately.</i>
						<li>Drafted architectural floor plans and elevations
							Created auto CAD electrical, mechanical and architectural drawings/diagrams based upon engineering designs
							Knowledge of all commands</li>
					</ul>
					<h6 style="color:blue">Autocad Script writting is a plus</h6>
				</div>
				<!-- <div class="col">
					<h5>SALARY SR2250</h5>
					<P>+ SR300 Food allowance</P>
				</div> -->
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				<!-- <button type="button" class="btn btn-primary">Apply Now</button> -->
			</div>
		</div>
	</div>
</div>

			


<script>
	$('#myModal').modal('show')
</script>